import { render } from "./ConvertToPostsCard.vue?vue&type=template&id=03d82458"
import script from "./ConvertToPostsCard.vue?vue&type=script&lang=js"
export * from "./ConvertToPostsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__